"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var TabPanel = function (_a) {
    var children = _a.children, selectedTab = _a.selectedTab, onTabChange = _a.onTabChange, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("div", { className: "TabPanel ".concat(className) },
        react_1.default.createElement("div", { className: "TabButtons mt-4 flex" }, children.map(function (c, i) {
            var buttonClassName;
            var buttonTitleClassName;
            if (i === selectedTab) {
                buttonClassName = "bg-white border border-b-0";
                buttonTitleClassName = "text-grey-dark";
            }
            else {
                buttonClassName = "bg-teal border";
                buttonTitleClassName = "text-white underline";
            }
            return (react_1.default.createElement(_1.TextButton, { className: "TabButton rounded-t-lg px-4 py-1 ".concat(buttonClassName), key: i, onClick: onTabChange ? function () { return onTabChange(i); } : undefined },
                react_1.default.createElement("span", { className: "text-base font-bold ".concat(buttonTitleClassName) }, c.props.title)));
        })),
        children[selectedTab]));
};
exports.TabPanel = TabPanel;
